'use client';
import './Button.scss';
import {ReactNode, useRef, useState, ElementType, ComponentPropsWithRef, RefObject, useEffect} from 'react';
import { useOutsideAlerter } from 'hooks';
import {usePathname} from 'next/navigation'

type ToggleButtonProps<T extends ElementType> = {
  as: T;
  children: ReactNode;
  className?: string;
  childRef?: RefObject<HTMLElement>;
} & ComponentPropsWithRef<T>;

export const ToggleButton = <T extends ElementType>({
  as: BtnType,
  children,
  className,
  childRef,
  ...props
}: ToggleButtonProps<T>) => {

  const pathname = usePathname()

  const btnRef = useRef(null);

  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    setIsActive(false);
  }, [pathname]);

  const handleClick = () => {
    setIsActive(!isActive);
  }
  const handleClickOutside = () => setIsActive(false);

  className = className + ' toggle-button ';

  useOutsideAlerter([btnRef, childRef], handleClickOutside, childRef);

  return (
        <BtnType
            ref={btnRef}
            onMouseDown={handleClick}
          // onClick={handleClick}
          className={isActive ? ' is-active ' + className : className}
          {...props}
          aria-expanded={isActive}
        >
          {children}
        </BtnType>
  );
}
